import React, { Component } from 'react';
import { apisettigs } from '../../settings';
import './Home.css';


class Home extends Component{
    constructor(props) {        
        super(props);

        this.state = {
            show: false,
            nOrders: null,
            nRequests: null,
            nMensagens: null,
        };
    }

    componentDidMount(){
    }


    showHome = () => {
        this.setState({show: true});

        const requestOptions2 = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json charset=utf-8', },
            body: JSON.stringify({ userid: window.sessionStorage.getItem("userId") })
        };
        
        fetch(apisettigs.endpoints.homeShowPerms, requestOptions2)
        .then(response => response.json())
        .then(data => {
            //console.log(data)

            if(data.orderApprover === 'Y' || data.requestApprover === 'Y'){
                try{
                    document.getElementById('hmT1').classList.remove('d-none');
                }catch{}
            }
            else{
                try{
                    document.getElementById('hmT1').classList.add('d-none');
                }catch{}
            }


            if (data.orderApprover === 'Y'){
                try{
                    //document.getElementById('ordTab').classList.remove('d-none');
                    document.getElementById('rcount').classList.remove('d-none');
                }catch{}
            }
            else{
                try{
                    //document.getElementById('ordTab').classList.add('d-none');
                    document.getElementById('rcount').classList.add('d-none');
                }catch{}
            }

            if (data.requestApprover === 'Y'){
                try{
                    //document.getElementById('solTab').classList.remove('d-none');
                    document.getElementById('scount').classList.remove('d-none');
                }catch{}
            }
            else{
                try{
                    //document.getElementById('solTab').classList.add('d-none');
                    document.getElementById('scount').classList.add('d-none');
                }catch{}
            }
        });


        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json charset=utf-8', },
            body: JSON.stringify({ userid: window.sessionStorage.getItem("userId") })
        };
        
        fetch(apisettigs.endpoints.home, requestOptions)
        .then(response => response.json())
        .then(data => {
            //console.log(data);
            this.setState({nOrders: data.orders});
            this.setState({nRequests: data.requests});
            this.setState({nMensagens: data.mesages});
        });
    }
    
    hideHome = () => {
        this.setState({show: false});
    }
    
    showSolic = () => {
        this.hideHome();
        this.props.showSolic();

        let tabs = document.getElementsByClassName('Tab');
        for (var i = 0, len = tabs.length; i < len; i++) {
            tabs[i].classList.remove('active');
        }

        document.getElementById('solTab').classList.add('active');
    }

    showOrdem = () => {
        this.hideHome();
        this.props.showOrd();

        let tabs = document.getElementsByClassName('Tab');
        for (var i = 0, len = tabs.length; i < len; i++) {
            tabs[i].classList.remove('active');
        }

        document.getElementById('ordTab').classList.add('active');
    }

    showCentralMensagens = () => {
        this.hideHome();

        let tabs = document.getElementsByClassName('Tab');
        for (var i = 0, len = tabs.length; i < len; i++) {
            tabs[i].classList.remove('active');
        }

        document.getElementById('msgTab').classList.add('active');

        this.props.showCentralMsg();
    }



    render(){
        if (this.state.show === true){
            return (
                <>
                    <div className='container mt-5 hTitle d-none' id='hmT1'>
                        Aguardando sua aprovação: 
                    </div>
                    <div className='container mt-5 hContnt'>

                        <div className='d-flex d-none' id='scount'>
                            <div className='circle' onClick={this.showSolic}>
                                {this.state.nRequests}
                            </div>
                            <div className='d-flex adptT' onClick={this.showSolic} >
                                Solicitações
                            </div>
                        </div>

                        <div className='d-flex mt-4 d-none' id='rcount'>
                            <div className='circle' onClick={this.showOrdem}>
                                {this.state.nOrders}
                            </div>
                            <div className='d-flex adptT2' onClick={this.showOrdem}>
                                Ordens
                            </div>
                        </div>
                    </div>    

                    <div className='container mt-5 hTitle'>
                        Mensagens não lidas: 
                    </div>
                    <div className='container mt-5 hContnt'>
                        <div className='d-flex mt-4' id='mcount'>
                                <div className='circle2' onClick={this.showOrdem}>
                                {this.state.nMensagens}
                                </div>
                                <div className='d-flex adptT2' onClick={this.showCentralMensagens}>
                                    Mensagens
                                </div>
                        </div> 
                    </div>            
                </>
                
            );
        }
        else{
            return null;
        }
        
    }

}

export default Home;